export const TextDisplayLarge = ({text, color, children}) => {
    return <span className={`desktop-lg:ont-[700] desktop-lg:text-[54px] desktop-lg:leading-[64px] font-[600] text-[36px] leading-[44px] text-${color} font-sans`}>{text}{children}</span>
};

export const TextDisplayMedium = ({text, color, children}) => {
    return <span className={`desktop-lg:font-[600] desktop-lg:text-[40px] desktop-lg:leading-[52px] font-[600] text-[32px] leading-[40px] text-${color} font-sans`}>{text}{children}</span>
};

export const TextDisplaySmall = ({text, color, children}) => {
    return <span className={`desktop-lg:font-[600] desktop-lg:text-[36px] desktop-lg:leading-[44px] font-[600] text-[28px] leading-[36px] text-${color} font-sans`}>{text}{children}</span>
};

export const TextHeadlineLarge = ({text, color, children}) => {
    return <span className={`desktop-lg:font-[600] desktop-lg:text-[32px] desktop-lg:leading-[40px] font-[600] text-[20px] leading-[32px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextHeadlineMedium = ({text, color, children}) => {
    return <span className={`desktop-lg:font-[600] desktop-lg:text-[28px] desktop-lg:leading-[36px] font-[600] text-[24px] leading-[32px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextHeadlineSmall = ({text, color, children}) => {
    return <span className={`desktop-lg:font-[600] desktop-lg:text-[24px] desktop-lg:leading-[32px] font-[500] text-[20px] leading-[28px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextTitleLerge = ({text, color, children}) => {
    return <span className={`desktop-lg:font-[500] desktop-lg:text-[20px] desktop-lg:leading-[28px] font-[500] text-[16px] leading-[24px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextTitleMedium = ({text, color, children}) => {
    return <span className={`font-[500] text-[16px] leading-[24px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextTitleSmall = ({text, color, children}) => {
    return <span className={`font-[500] text-[14px] leading-[20px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextBodyXLarge = ({text, color, children}) => {
    return <span className={`desktop-lg:font-[400] desktop-lg:text-[20px] desktop-lg:leading-[28px] font-[400] text-[14px] leading-[20px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextBodyLarge = ({text, color, children}) => {
    return <span className={`desktop-lg:font-[400] desktop-lg:text-[16px] desktop-lg:leading-[24px] font-[400] text-[14px] leading-[20px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextBodyMedium = ({text, color, children}) => {
    return <span className={`font-[400] text-[14px] leading-[20px] text-${color} font-sans`}>{text}{children}</span>

}

export const TextBodySmall = ({text, color, children}) => {
    return <span className={`font-[400] text-[12px] leading-[16px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextLabelLarge = ({text, color, children}) => {
    return <span className={`font-[500] text-[14px] leading-[20px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextLabelMedium = ({text, color, children}) => {
    return <span className={`font-[500] text-[12px] leading-[16px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextLabelSmall = ({text, color, children}) => {
    return <span className={`font-[500] text-[11px] leading-[16px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextLabelLargeProminent = ({text, color, children}) => {
    return <span className={`font-[600] text-[14px] leading-[20px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextTitleSmallProminent = ({text, color, children}) => {
    return <span className={`font-[600] text-[14px] leading-[20px] text-${color} font-sans`}>{text}{children}</span>
};

export const TextTableCell = ({text, color, children}) => {
    return <span className={`font-[400] text-[13px] leading-[18px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextLabelTable = ({text, color, children}) => {
    return <span className={`font-[600] text-[14px] leading-[20px] text-${color} text-right font-sans`}>{text}{children}</span>
}

export const TextSectionHeading = ({text, color, children}) => {
    return <span className={`desktop-lg:font-[700] desktop-lg:text-[30px] desktop-lg:leading-[38px] font-[700] text-[22px] leading-[30px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextStatusHeader = ({text, color, children}) => {
    return <span className={`font-[600] text-[16px] leading-[24px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextTaskName = ({text, color, children}) => {
    return <span className={`font-[600] text-[16px] leading-[24px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextTaskMeta = ({text, color, children}) => {
    return <span className={`font-[500] text-[12px] leading-[16px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextDocumentLabel = ({text, color, children}) => {
    return <span className={`font-[500] text-[12px] leading-[16px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextDocumentName = ({text, color, children}) => {
    return <span className={`font-[500] text-[12px] leading-[16px] text-${color} font-sans`}>{text}{children}</span>
}

export const TextBadge = ({text, color, children}) => {
    return <span className={`font-[500] text-[12px] leading-[16px] text-${color} font-sans`}>{text}{children}</span>
}